export const replaceUrlParam = (url: string, paramName: string, value: number | string) => {
  const pattern = `(${paramName}=)[^\\&]+`;
  const regExp = new RegExp(pattern);
  return url.replace(regExp, `$1${value}`);
};
